// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BestChainsawsUkRouteImport } from './routes/best-chainsaws-uk'
import { Route as BestGeneratorsUkRouteImport } from './routes/best-generators-uk'
import { Route as BestLawnMowersUkRouteImport } from './routes/best-lawn-mowers-uk'
import { Route as BestPressureWashersUkRouteImport } from './routes/best-pressure-washers-uk'
import { Route as CordlessLeafBlowerRouteImport } from './routes/cordless-leaf-blower'
import { Route as LawnMowerGuideRouteImport } from './routes/lawn-mower-guide'
import { Route as LeafBlowerGuideRouteImport } from './routes/leaf-blower-guide'
import { Route as ProductReviewServiceRouteImport } from './routes/product-review-service'
import { Route as SubmitContentRouteImport } from './routes/submit-content'
import { Route as SlugIndexRouteImport } from './routes/$slug/index'
import { Route as SlugProductSlugRouteImport } from './routes/$slug/$productSlug'
import { Route as SlugBuyingGuidesRouteImport } from './routes/$slug/buying-guides'
import { Route as SlugReviewsRouteImport } from './routes/$slug/reviews'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAiContentStudioRouteImport } from './routes/admin/ai-content-studio'
import { Route as AdminAllProductsRouteImport } from './routes/admin/all-products'
import { Route as AdminAmazonImportRouteImport } from './routes/admin/amazon-import'
import { Route as AdminAuthorsRouteImport } from './routes/admin/authors'
import { Route as AdminBulkArticlesRouteImport } from './routes/admin/bulk-articles'
import { Route as AdminBulkImagesRouteImport } from './routes/admin/bulk-images'
import { Route as AdminCalendarRouteImport } from './routes/admin/calendar'
import { Route as AdminCategoriesRouteImport } from './routes/admin/categories'
import { Route as AdminCategoryMappingRouteImport } from './routes/admin/category-mapping'
import { Route as AdminCommentsRouteImport } from './routes/admin/comments'
import { Route as AdminComparisonsRouteImport } from './routes/admin/comparisons'
import { Route as AdminCompetitorRouteImport } from './routes/admin/competitor'
import { Route as AdminContentRouteImport } from './routes/admin/content'
import { Route as AdminContentPlanRouteImport } from './routes/admin/content-plan'
import { Route as AdminEmailAnalyticsRouteImport } from './routes/admin/email-analytics'
import { Route as AdminEmailsRouteImport } from './routes/admin/emails'
import { Route as AdminGenerateRouteImport } from './routes/admin/generate'
import { Route as AdminImportRouteImport } from './routes/admin/import'
import { Route as AdminNewsletterRouteImport } from './routes/admin/newsletter'
import { Route as AdminNotFoundLogRouteImport } from './routes/admin/not-found-log'
import { Route as AdminProductsByRetailerRouteImport } from './routes/admin/products-by-retailer'
import { Route as AdminRedirectsRouteImport } from './routes/admin/redirects'
import { Route as AdminSidebarAdsRouteImport } from './routes/admin/sidebar-ads'
import { Route as AdminSubscribersRouteImport } from './routes/admin/subscribers'
import { Route as AdviceSectionSlugRouteImport } from './routes/advice/$sectionSlug'
import { Route as AirCompressorsIndexRouteImport } from './routes/air-compressors/index'
import { Route as AirCompressorsSlugRouteImport } from './routes/air-compressors/$slug'
import { Route as AirCompressorsBuyingGuidesRouteImport } from './routes/air-compressors/buying-guides'
import { Route as AirCompressorsReviewsRouteImport } from './routes/air-compressors/reviews'
import { Route as ArticlesIndexRouteImport } from './routes/articles/index'
import { Route as ArticlesSlugRouteImport } from './routes/articles/$slug'
import { Route as AuthorsIndexRouteImport } from './routes/authors/index'
import { Route as AuthorsSlugRouteImport } from './routes/authors/$slug'
import { Route as BestSlugRouteImport } from './routes/best/$slug'
import { Route as BrowseIndexRouteImport } from './routes/browse/index'
import { Route as BrowsePageRouteImport } from './routes/browse/$page'
import { Route as CategoryCategorySlugRouteImport } from './routes/category/$categorySlug'
import { Route as ChainsawsIndexRouteImport } from './routes/chainsaws/index'
import { Route as ChainsawsSlugRouteImport } from './routes/chainsaws/$slug'
import { Route as ChainsawsBuyingGuidesRouteImport } from './routes/chainsaws/buying-guides'
import { Route as ChainsawsReviewsRouteImport } from './routes/chainsaws/reviews'
import { Route as CompareSlugRouteImport } from './routes/compare/$slug'
import { Route as DealsAmazonGardenDealsRouteImport } from './routes/deals/amazon-garden-deals'
import { Route as GeneratorsIndexRouteImport } from './routes/generators/index'
import { Route as GeneratorsSlugRouteImport } from './routes/generators/$slug'
import { Route as GeneratorsBuyingGuidesRouteImport } from './routes/generators/buying-guides'
import { Route as GeneratorsReviewsRouteImport } from './routes/generators/reviews'
import { Route as GiftsFathersDayRouteImport } from './routes/gifts/fathers-day'
import { Route as GuidesBestLeafBlowersUkRouteImport } from './routes/guides/best-leaf-blowers-uk'
import { Route as LawnMowersIndexRouteImport } from './routes/lawn-mowers/index'
import { Route as LawnMowersSlugRouteImport } from './routes/lawn-mowers/$slug'
import { Route as LawnMowersBuyingGuidesRouteImport } from './routes/lawn-mowers/buying-guides'
import { Route as LawnMowersReviewsRouteImport } from './routes/lawn-mowers/reviews'
import { Route as PlantsIndexRouteImport } from './routes/plants/index'
import { Route as PlantsSlugRouteImport } from './routes/plants/$slug'
import { Route as PressureWashersIndexRouteImport } from './routes/pressure-washers/index'
import { Route as PressureWashersSlugRouteImport } from './routes/pressure-washers/$slug'
import { Route as PressureWashersBuyingGuidesRouteImport } from './routes/pressure-washers/buying-guides'
import { Route as PressureWashersReviewsRouteImport } from './routes/pressure-washers/reviews'
import { Route as ProductSlugRouteImport } from './routes/product/$slug'
import { Route as ProductsCategorySlugRouteImport } from './routes/products/$categorySlug'
import { Route as ReviewsSectionSlugRouteImport } from './routes/reviews/$sectionSlug'
import { Route as ShopSlugRouteImport } from './routes/shop/$slug'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable/oauth/consent'
import { Route as AdminArticlesIndexRouteImport } from './routes/admin/articles/index'
import { Route as AdminArticlesIdRouteImport } from './routes/admin/articles/$id'
import { Route as AdminChainsawsIndexRouteImport } from './routes/admin/chainsaws/index'
import { Route as AdminChainsawsIdRouteImport } from './routes/admin/chainsaws/$id'
import { Route as AdminDataFeedsIndexRouteImport } from './routes/admin/data-feeds/index'
import { Route as AdminGeneratorsIndexRouteImport } from './routes/admin/generators/index'
import { Route as AdminGeneratorsIdRouteImport } from './routes/admin/generators/$id'
import { Route as AdminLawnMowersIndexRouteImport } from './routes/admin/lawn-mowers/index'
import { Route as AdminLawnMowersIdRouteImport } from './routes/admin/lawn-mowers/$id'
import { Route as AdminLawnMowersBulkImportRouteImport } from './routes/admin/lawn-mowers/bulk-import'
import { Route as AdminLawnMowersDuplicatesRouteImport } from './routes/admin/lawn-mowers/duplicates'
import { Route as AdminPagesIndexRouteImport } from './routes/admin/pages/index'
import { Route as AdminPagesIdRouteImport } from './routes/admin/pages/$id'
import { Route as AdminPressureWashersIndexRouteImport } from './routes/admin/pressure-washers/index'
import { Route as AdminPressureWashersIdRouteImport } from './routes/admin/pressure-washers/$id'
import { Route as AdminProductLandingsIndexRouteImport } from './routes/admin/product-landings/index'
import { Route as AdminProductLandingsIdRouteImport } from './routes/admin/product-landings/$id'
import { Route as AdminProductsIndexRouteImport } from './routes/admin/products/index'
import { Route as AdminShoppableLandingsIndexRouteImport } from './routes/admin/shoppable-landings/index'
import { Route as AdminShoppableLandingsIdRouteImport } from './routes/admin/shoppable-landings/$id'
import { Route as AdminTopListsIndexRouteImport } from './routes/admin/top-lists/index'
import { Route as AdminTopListsIdRouteImport } from './routes/admin/top-lists/$id'
import { Route as AirCompressorsCategorySlugRouteImport } from './routes/air-compressors/category/$slug'
import { Route as BrandBrandSlugIndexRouteImport } from './routes/brand/$brandSlug/index'
import { Route as BrandBrandSlugCategorySlugRouteImport } from './routes/brand/$brandSlug/$categorySlug'
import { Route as BrandHyundaiSawsRouteImport } from './routes/brand/hyundai/saws'
import { Route as ChainsawsCategorySlugRouteImport } from './routes/chainsaws/category/$slug'
import { Route as GeneratorsBrandFilterValueRouteImport } from './routes/generators/brand/$filterValue'
import { Route as GeneratorsCategorySlugRouteImport } from './routes/generators/category/$slug'
import { Route as GeneratorsFuelFilterValueRouteImport } from './routes/generators/fuel/$filterValue'
import { Route as GeneratorsTypeFilterValueRouteImport } from './routes/generators/type/$filterValue'
import { Route as LawnMowersBrandFilterValueRouteImport } from './routes/lawn-mowers/brand/$filterValue'
import { Route as LawnMowersCategorySlugRouteImport } from './routes/lawn-mowers/category/$slug'
import { Route as LawnMowersPowerFilterValueRouteImport } from './routes/lawn-mowers/power/$filterValue'
import { Route as LawnMowersTypeFilterValueRouteImport } from './routes/lawn-mowers/type/$filterValue'
import { Route as PressureWashersCategorySlugRouteImport } from './routes/pressure-washers/category/$slug'
import { Route as AdminDataFeedsIdProductsRouteImport } from './routes/admin/data-feeds/$id/products'
import { Route as AdminProductsHubIndexRouteImport } from './routes/admin/products/$hub/index'
import { Route as AdminProductsHubIdRouteImport } from './routes/admin/products/$hub/$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BestChainsawsUkRoute = BestChainsawsUkRouteImport.update({
            id: '/best-chainsaws-uk',path: '/best-chainsaws-uk',getParentRoute: () => rootRouteImport
          })
const BestGeneratorsUkRoute = BestGeneratorsUkRouteImport.update({
            id: '/best-generators-uk',path: '/best-generators-uk',getParentRoute: () => rootRouteImport
          })
const BestLawnMowersUkRoute = BestLawnMowersUkRouteImport.update({
            id: '/best-lawn-mowers-uk',path: '/best-lawn-mowers-uk',getParentRoute: () => rootRouteImport
          })
const BestPressureWashersUkRoute = BestPressureWashersUkRouteImport.update({
            id: '/best-pressure-washers-uk',path: '/best-pressure-washers-uk',getParentRoute: () => rootRouteImport
          })
const CordlessLeafBlowerRoute = CordlessLeafBlowerRouteImport.update({
            id: '/cordless-leaf-blower',path: '/cordless-leaf-blower',getParentRoute: () => rootRouteImport
          })
const LawnMowerGuideRoute = LawnMowerGuideRouteImport.update({
            id: '/lawn-mower-guide',path: '/lawn-mower-guide',getParentRoute: () => rootRouteImport
          })
const LeafBlowerGuideRoute = LeafBlowerGuideRouteImport.update({
            id: '/leaf-blower-guide',path: '/leaf-blower-guide',getParentRoute: () => rootRouteImport
          })
const ProductReviewServiceRoute = ProductReviewServiceRouteImport.update({
            id: '/product-review-service',path: '/product-review-service',getParentRoute: () => rootRouteImport
          })
const SubmitContentRoute = SubmitContentRouteImport.update({
            id: '/submit-content',path: '/submit-content',getParentRoute: () => rootRouteImport
          })
const SlugIndexRoute = SlugIndexRouteImport.update({
            id: '/$slug/',path: '/$slug/',getParentRoute: () => rootRouteImport
          })
const SlugProductSlugRoute = SlugProductSlugRouteImport.update({
            id: '/$slug/$productSlug',path: '/$slug/$productSlug',getParentRoute: () => rootRouteImport
          })
const SlugBuyingGuidesRoute = SlugBuyingGuidesRouteImport.update({
            id: '/$slug/buying-guides',path: '/$slug/buying-guides',getParentRoute: () => rootRouteImport
          })
const SlugReviewsRoute = SlugReviewsRouteImport.update({
            id: '/$slug/reviews',path: '/$slug/reviews',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAiContentStudioRoute = AdminAiContentStudioRouteImport.update({
            id: '/admin/ai-content-studio',path: '/admin/ai-content-studio',getParentRoute: () => rootRouteImport
          })
const AdminAllProductsRoute = AdminAllProductsRouteImport.update({
            id: '/admin/all-products',path: '/admin/all-products',getParentRoute: () => rootRouteImport
          })
const AdminAmazonImportRoute = AdminAmazonImportRouteImport.update({
            id: '/admin/amazon-import',path: '/admin/amazon-import',getParentRoute: () => rootRouteImport
          })
const AdminAuthorsRoute = AdminAuthorsRouteImport.update({
            id: '/admin/authors',path: '/admin/authors',getParentRoute: () => rootRouteImport
          })
const AdminBulkArticlesRoute = AdminBulkArticlesRouteImport.update({
            id: '/admin/bulk-articles',path: '/admin/bulk-articles',getParentRoute: () => rootRouteImport
          })
const AdminBulkImagesRoute = AdminBulkImagesRouteImport.update({
            id: '/admin/bulk-images',path: '/admin/bulk-images',getParentRoute: () => rootRouteImport
          })
const AdminCalendarRoute = AdminCalendarRouteImport.update({
            id: '/admin/calendar',path: '/admin/calendar',getParentRoute: () => rootRouteImport
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/admin/categories',path: '/admin/categories',getParentRoute: () => rootRouteImport
          })
const AdminCategoryMappingRoute = AdminCategoryMappingRouteImport.update({
            id: '/admin/category-mapping',path: '/admin/category-mapping',getParentRoute: () => rootRouteImport
          })
const AdminCommentsRoute = AdminCommentsRouteImport.update({
            id: '/admin/comments',path: '/admin/comments',getParentRoute: () => rootRouteImport
          })
const AdminComparisonsRoute = AdminComparisonsRouteImport.update({
            id: '/admin/comparisons',path: '/admin/comparisons',getParentRoute: () => rootRouteImport
          })
const AdminCompetitorRoute = AdminCompetitorRouteImport.update({
            id: '/admin/competitor',path: '/admin/competitor',getParentRoute: () => rootRouteImport
          })
const AdminContentRoute = AdminContentRouteImport.update({
            id: '/admin/content',path: '/admin/content',getParentRoute: () => rootRouteImport
          })
const AdminContentPlanRoute = AdminContentPlanRouteImport.update({
            id: '/admin/content-plan',path: '/admin/content-plan',getParentRoute: () => rootRouteImport
          })
const AdminEmailAnalyticsRoute = AdminEmailAnalyticsRouteImport.update({
            id: '/admin/email-analytics',path: '/admin/email-analytics',getParentRoute: () => rootRouteImport
          })
const AdminEmailsRoute = AdminEmailsRouteImport.update({
            id: '/admin/emails',path: '/admin/emails',getParentRoute: () => rootRouteImport
          })
const AdminGenerateRoute = AdminGenerateRouteImport.update({
            id: '/admin/generate',path: '/admin/generate',getParentRoute: () => rootRouteImport
          })
const AdminImportRoute = AdminImportRouteImport.update({
            id: '/admin/import',path: '/admin/import',getParentRoute: () => rootRouteImport
          })
const AdminNewsletterRoute = AdminNewsletterRouteImport.update({
            id: '/admin/newsletter',path: '/admin/newsletter',getParentRoute: () => rootRouteImport
          })
const AdminNotFoundLogRoute = AdminNotFoundLogRouteImport.update({
            id: '/admin/not-found-log',path: '/admin/not-found-log',getParentRoute: () => rootRouteImport
          })
const AdminProductsByRetailerRoute = AdminProductsByRetailerRouteImport.update({
            id: '/admin/products-by-retailer',path: '/admin/products-by-retailer',getParentRoute: () => rootRouteImport
          })
const AdminRedirectsRoute = AdminRedirectsRouteImport.update({
            id: '/admin/redirects',path: '/admin/redirects',getParentRoute: () => rootRouteImport
          })
const AdminSidebarAdsRoute = AdminSidebarAdsRouteImport.update({
            id: '/admin/sidebar-ads',path: '/admin/sidebar-ads',getParentRoute: () => rootRouteImport
          })
const AdminSubscribersRoute = AdminSubscribersRouteImport.update({
            id: '/admin/subscribers',path: '/admin/subscribers',getParentRoute: () => rootRouteImport
          })
const AdviceSectionSlugRoute = AdviceSectionSlugRouteImport.update({
            id: '/advice/$sectionSlug',path: '/advice/$sectionSlug',getParentRoute: () => rootRouteImport
          })
const AirCompressorsIndexRoute = AirCompressorsIndexRouteImport.update({
            id: '/air-compressors/',path: '/air-compressors/',getParentRoute: () => rootRouteImport
          })
const AirCompressorsSlugRoute = AirCompressorsSlugRouteImport.update({
            id: '/air-compressors/$slug',path: '/air-compressors/$slug',getParentRoute: () => rootRouteImport
          })
const AirCompressorsBuyingGuidesRoute = AirCompressorsBuyingGuidesRouteImport.update({
            id: '/air-compressors/buying-guides',path: '/air-compressors/buying-guides',getParentRoute: () => rootRouteImport
          })
const AirCompressorsReviewsRoute = AirCompressorsReviewsRouteImport.update({
            id: '/air-compressors/reviews',path: '/air-compressors/reviews',getParentRoute: () => rootRouteImport
          })
const ArticlesIndexRoute = ArticlesIndexRouteImport.update({
            id: '/articles/',path: '/articles/',getParentRoute: () => rootRouteImport
          })
const ArticlesSlugRoute = ArticlesSlugRouteImport.update({
            id: '/articles/$slug',path: '/articles/$slug',getParentRoute: () => rootRouteImport
          })
const AuthorsIndexRoute = AuthorsIndexRouteImport.update({
            id: '/authors/',path: '/authors/',getParentRoute: () => rootRouteImport
          })
const AuthorsSlugRoute = AuthorsSlugRouteImport.update({
            id: '/authors/$slug',path: '/authors/$slug',getParentRoute: () => rootRouteImport
          })
const BestSlugRoute = BestSlugRouteImport.update({
            id: '/best/$slug',path: '/best/$slug',getParentRoute: () => rootRouteImport
          })
const BrowseIndexRoute = BrowseIndexRouteImport.update({
            id: '/browse/',path: '/browse/',getParentRoute: () => rootRouteImport
          })
const BrowsePageRoute = BrowsePageRouteImport.update({
            id: '/browse/$page',path: '/browse/$page',getParentRoute: () => rootRouteImport
          })
const CategoryCategorySlugRoute = CategoryCategorySlugRouteImport.update({
            id: '/category/$categorySlug',path: '/category/$categorySlug',getParentRoute: () => rootRouteImport
          })
const ChainsawsIndexRoute = ChainsawsIndexRouteImport.update({
            id: '/chainsaws/',path: '/chainsaws/',getParentRoute: () => rootRouteImport
          })
const ChainsawsSlugRoute = ChainsawsSlugRouteImport.update({
            id: '/chainsaws/$slug',path: '/chainsaws/$slug',getParentRoute: () => rootRouteImport
          })
const ChainsawsBuyingGuidesRoute = ChainsawsBuyingGuidesRouteImport.update({
            id: '/chainsaws/buying-guides',path: '/chainsaws/buying-guides',getParentRoute: () => rootRouteImport
          })
const ChainsawsReviewsRoute = ChainsawsReviewsRouteImport.update({
            id: '/chainsaws/reviews',path: '/chainsaws/reviews',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const DealsAmazonGardenDealsRoute = DealsAmazonGardenDealsRouteImport.update({
            id: '/deals/amazon-garden-deals',path: '/deals/amazon-garden-deals',getParentRoute: () => rootRouteImport
          })
const GeneratorsIndexRoute = GeneratorsIndexRouteImport.update({
            id: '/generators/',path: '/generators/',getParentRoute: () => rootRouteImport
          })
const GeneratorsSlugRoute = GeneratorsSlugRouteImport.update({
            id: '/generators/$slug',path: '/generators/$slug',getParentRoute: () => rootRouteImport
          })
const GeneratorsBuyingGuidesRoute = GeneratorsBuyingGuidesRouteImport.update({
            id: '/generators/buying-guides',path: '/generators/buying-guides',getParentRoute: () => rootRouteImport
          })
const GeneratorsReviewsRoute = GeneratorsReviewsRouteImport.update({
            id: '/generators/reviews',path: '/generators/reviews',getParentRoute: () => rootRouteImport
          })
const GiftsFathersDayRoute = GiftsFathersDayRouteImport.update({
            id: '/gifts/fathers-day',path: '/gifts/fathers-day',getParentRoute: () => rootRouteImport
          })
const GuidesBestLeafBlowersUkRoute = GuidesBestLeafBlowersUkRouteImport.update({
            id: '/guides/best-leaf-blowers-uk',path: '/guides/best-leaf-blowers-uk',getParentRoute: () => rootRouteImport
          })
const LawnMowersIndexRoute = LawnMowersIndexRouteImport.update({
            id: '/lawn-mowers/',path: '/lawn-mowers/',getParentRoute: () => rootRouteImport
          })
const LawnMowersSlugRoute = LawnMowersSlugRouteImport.update({
            id: '/lawn-mowers/$slug',path: '/lawn-mowers/$slug',getParentRoute: () => rootRouteImport
          })
const LawnMowersBuyingGuidesRoute = LawnMowersBuyingGuidesRouteImport.update({
            id: '/lawn-mowers/buying-guides',path: '/lawn-mowers/buying-guides',getParentRoute: () => rootRouteImport
          })
const LawnMowersReviewsRoute = LawnMowersReviewsRouteImport.update({
            id: '/lawn-mowers/reviews',path: '/lawn-mowers/reviews',getParentRoute: () => rootRouteImport
          })
const PlantsIndexRoute = PlantsIndexRouteImport.update({
            id: '/plants/',path: '/plants/',getParentRoute: () => rootRouteImport
          })
const PlantsSlugRoute = PlantsSlugRouteImport.update({
            id: '/plants/$slug',path: '/plants/$slug',getParentRoute: () => rootRouteImport
          })
const PressureWashersIndexRoute = PressureWashersIndexRouteImport.update({
            id: '/pressure-washers/',path: '/pressure-washers/',getParentRoute: () => rootRouteImport
          })
const PressureWashersSlugRoute = PressureWashersSlugRouteImport.update({
            id: '/pressure-washers/$slug',path: '/pressure-washers/$slug',getParentRoute: () => rootRouteImport
          })
const PressureWashersBuyingGuidesRoute = PressureWashersBuyingGuidesRouteImport.update({
            id: '/pressure-washers/buying-guides',path: '/pressure-washers/buying-guides',getParentRoute: () => rootRouteImport
          })
const PressureWashersReviewsRoute = PressureWashersReviewsRouteImport.update({
            id: '/pressure-washers/reviews',path: '/pressure-washers/reviews',getParentRoute: () => rootRouteImport
          })
const ProductSlugRoute = ProductSlugRouteImport.update({
            id: '/product/$slug',path: '/product/$slug',getParentRoute: () => rootRouteImport
          })
const ProductsCategorySlugRoute = ProductsCategorySlugRouteImport.update({
            id: '/products/$categorySlug',path: '/products/$categorySlug',getParentRoute: () => rootRouteImport
          })
const ReviewsSectionSlugRoute = ReviewsSectionSlugRouteImport.update({
            id: '/reviews/$sectionSlug',path: '/reviews/$sectionSlug',getParentRoute: () => rootRouteImport
          })
const ShopSlugRoute = ShopSlugRouteImport.update({
            id: '/shop/$slug',path: '/shop/$slug',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AdminArticlesIndexRoute = AdminArticlesIndexRouteImport.update({
            id: '/admin/articles/',path: '/admin/articles/',getParentRoute: () => rootRouteImport
          })
const AdminArticlesIdRoute = AdminArticlesIdRouteImport.update({
            id: '/admin/articles/$id',path: '/admin/articles/$id',getParentRoute: () => rootRouteImport
          })
const AdminChainsawsIndexRoute = AdminChainsawsIndexRouteImport.update({
            id: '/admin/chainsaws/',path: '/admin/chainsaws/',getParentRoute: () => rootRouteImport
          })
const AdminChainsawsIdRoute = AdminChainsawsIdRouteImport.update({
            id: '/admin/chainsaws/$id',path: '/admin/chainsaws/$id',getParentRoute: () => rootRouteImport
          })
const AdminDataFeedsIndexRoute = AdminDataFeedsIndexRouteImport.update({
            id: '/admin/data-feeds/',path: '/admin/data-feeds/',getParentRoute: () => rootRouteImport
          })
const AdminGeneratorsIndexRoute = AdminGeneratorsIndexRouteImport.update({
            id: '/admin/generators/',path: '/admin/generators/',getParentRoute: () => rootRouteImport
          })
const AdminGeneratorsIdRoute = AdminGeneratorsIdRouteImport.update({
            id: '/admin/generators/$id',path: '/admin/generators/$id',getParentRoute: () => rootRouteImport
          })
const AdminLawnMowersIndexRoute = AdminLawnMowersIndexRouteImport.update({
            id: '/admin/lawn-mowers/',path: '/admin/lawn-mowers/',getParentRoute: () => rootRouteImport
          })
const AdminLawnMowersIdRoute = AdminLawnMowersIdRouteImport.update({
            id: '/admin/lawn-mowers/$id',path: '/admin/lawn-mowers/$id',getParentRoute: () => rootRouteImport
          })
const AdminLawnMowersBulkImportRoute = AdminLawnMowersBulkImportRouteImport.update({
            id: '/admin/lawn-mowers/bulk-import',path: '/admin/lawn-mowers/bulk-import',getParentRoute: () => rootRouteImport
          })
const AdminLawnMowersDuplicatesRoute = AdminLawnMowersDuplicatesRouteImport.update({
            id: '/admin/lawn-mowers/duplicates',path: '/admin/lawn-mowers/duplicates',getParentRoute: () => rootRouteImport
          })
const AdminPagesIndexRoute = AdminPagesIndexRouteImport.update({
            id: '/admin/pages/',path: '/admin/pages/',getParentRoute: () => rootRouteImport
          })
const AdminPagesIdRoute = AdminPagesIdRouteImport.update({
            id: '/admin/pages/$id',path: '/admin/pages/$id',getParentRoute: () => rootRouteImport
          })
const AdminPressureWashersIndexRoute = AdminPressureWashersIndexRouteImport.update({
            id: '/admin/pressure-washers/',path: '/admin/pressure-washers/',getParentRoute: () => rootRouteImport
          })
const AdminPressureWashersIdRoute = AdminPressureWashersIdRouteImport.update({
            id: '/admin/pressure-washers/$id',path: '/admin/pressure-washers/$id',getParentRoute: () => rootRouteImport
          })
const AdminProductLandingsIndexRoute = AdminProductLandingsIndexRouteImport.update({
            id: '/admin/product-landings/',path: '/admin/product-landings/',getParentRoute: () => rootRouteImport
          })
const AdminProductLandingsIdRoute = AdminProductLandingsIdRouteImport.update({
            id: '/admin/product-landings/$id',path: '/admin/product-landings/$id',getParentRoute: () => rootRouteImport
          })
const AdminProductsIndexRoute = AdminProductsIndexRouteImport.update({
            id: '/admin/products/',path: '/admin/products/',getParentRoute: () => rootRouteImport
          })
const AdminShoppableLandingsIndexRoute = AdminShoppableLandingsIndexRouteImport.update({
            id: '/admin/shoppable-landings/',path: '/admin/shoppable-landings/',getParentRoute: () => rootRouteImport
          })
const AdminShoppableLandingsIdRoute = AdminShoppableLandingsIdRouteImport.update({
            id: '/admin/shoppable-landings/$id',path: '/admin/shoppable-landings/$id',getParentRoute: () => rootRouteImport
          })
const AdminTopListsIndexRoute = AdminTopListsIndexRouteImport.update({
            id: '/admin/top-lists/',path: '/admin/top-lists/',getParentRoute: () => rootRouteImport
          })
const AdminTopListsIdRoute = AdminTopListsIdRouteImport.update({
            id: '/admin/top-lists/$id',path: '/admin/top-lists/$id',getParentRoute: () => rootRouteImport
          })
const AirCompressorsCategorySlugRoute = AirCompressorsCategorySlugRouteImport.update({
            id: '/air-compressors/category/$slug',path: '/air-compressors/category/$slug',getParentRoute: () => rootRouteImport
          })
const BrandBrandSlugIndexRoute = BrandBrandSlugIndexRouteImport.update({
            id: '/brand/$brandSlug/',path: '/brand/$brandSlug/',getParentRoute: () => rootRouteImport
          })
const BrandBrandSlugCategorySlugRoute = BrandBrandSlugCategorySlugRouteImport.update({
            id: '/brand/$brandSlug/$categorySlug',path: '/brand/$brandSlug/$categorySlug',getParentRoute: () => rootRouteImport
          })
const BrandHyundaiSawsRoute = BrandHyundaiSawsRouteImport.update({
            id: '/brand/hyundai/saws',path: '/brand/hyundai/saws',getParentRoute: () => rootRouteImport
          })
const ChainsawsCategorySlugRoute = ChainsawsCategorySlugRouteImport.update({
            id: '/chainsaws/category/$slug',path: '/chainsaws/category/$slug',getParentRoute: () => rootRouteImport
          })
const GeneratorsBrandFilterValueRoute = GeneratorsBrandFilterValueRouteImport.update({
            id: '/generators/brand/$filterValue',path: '/generators/brand/$filterValue',getParentRoute: () => rootRouteImport
          })
const GeneratorsCategorySlugRoute = GeneratorsCategorySlugRouteImport.update({
            id: '/generators/category/$slug',path: '/generators/category/$slug',getParentRoute: () => rootRouteImport
          })
const GeneratorsFuelFilterValueRoute = GeneratorsFuelFilterValueRouteImport.update({
            id: '/generators/fuel/$filterValue',path: '/generators/fuel/$filterValue',getParentRoute: () => rootRouteImport
          })
const GeneratorsTypeFilterValueRoute = GeneratorsTypeFilterValueRouteImport.update({
            id: '/generators/type/$filterValue',path: '/generators/type/$filterValue',getParentRoute: () => rootRouteImport
          })
const LawnMowersBrandFilterValueRoute = LawnMowersBrandFilterValueRouteImport.update({
            id: '/lawn-mowers/brand/$filterValue',path: '/lawn-mowers/brand/$filterValue',getParentRoute: () => rootRouteImport
          })
const LawnMowersCategorySlugRoute = LawnMowersCategorySlugRouteImport.update({
            id: '/lawn-mowers/category/$slug',path: '/lawn-mowers/category/$slug',getParentRoute: () => rootRouteImport
          })
const LawnMowersPowerFilterValueRoute = LawnMowersPowerFilterValueRouteImport.update({
            id: '/lawn-mowers/power/$filterValue',path: '/lawn-mowers/power/$filterValue',getParentRoute: () => rootRouteImport
          })
const LawnMowersTypeFilterValueRoute = LawnMowersTypeFilterValueRouteImport.update({
            id: '/lawn-mowers/type/$filterValue',path: '/lawn-mowers/type/$filterValue',getParentRoute: () => rootRouteImport
          })
const PressureWashersCategorySlugRoute = PressureWashersCategorySlugRouteImport.update({
            id: '/pressure-washers/category/$slug',path: '/pressure-washers/category/$slug',getParentRoute: () => rootRouteImport
          })
const AdminDataFeedsIdProductsRoute = AdminDataFeedsIdProductsRouteImport.update({
            id: '/admin/data-feeds/$id/products',path: '/admin/data-feeds/$id/products',getParentRoute: () => rootRouteImport
          })
const AdminProductsHubIndexRoute = AdminProductsHubIndexRouteImport.update({
            id: '/admin/products/$hub/',path: '/admin/products/$hub/',getParentRoute: () => rootRouteImport
          })
const AdminProductsHubIdRoute = AdminProductsHubIdRouteImport.update({
            id: '/admin/products/$hub/$id',path: '/admin/products/$hub/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AuthRoute: AuthRoute,BestChainsawsUkRoute: BestChainsawsUkRoute,BestGeneratorsUkRoute: BestGeneratorsUkRoute,BestLawnMowersUkRoute: BestLawnMowersUkRoute,BestPressureWashersUkRoute: BestPressureWashersUkRoute,CordlessLeafBlowerRoute: CordlessLeafBlowerRoute,LawnMowerGuideRoute: LawnMowerGuideRoute,LeafBlowerGuideRoute: LeafBlowerGuideRoute,ProductReviewServiceRoute: ProductReviewServiceRoute,SubmitContentRoute: SubmitContentRoute,SlugProductSlugRoute: SlugProductSlugRoute,SlugBuyingGuidesRoute: SlugBuyingGuidesRoute,SlugReviewsRoute: SlugReviewsRoute,AdminAiContentStudioRoute: AdminAiContentStudioRoute,AdminAllProductsRoute: AdminAllProductsRoute,AdminAmazonImportRoute: AdminAmazonImportRoute,AdminAuthorsRoute: AdminAuthorsRoute,AdminBulkArticlesRoute: AdminBulkArticlesRoute,AdminBulkImagesRoute: AdminBulkImagesRoute,AdminCalendarRoute: AdminCalendarRoute,AdminCategoriesRoute: AdminCategoriesRoute,AdminCategoryMappingRoute: AdminCategoryMappingRoute,AdminCommentsRoute: AdminCommentsRoute,AdminComparisonsRoute: AdminComparisonsRoute,AdminCompetitorRoute: AdminCompetitorRoute,AdminContentRoute: AdminContentRoute,AdminContentPlanRoute: AdminContentPlanRoute,AdminEmailAnalyticsRoute: AdminEmailAnalyticsRoute,AdminEmailsRoute: AdminEmailsRoute,AdminGenerateRoute: AdminGenerateRoute,AdminImportRoute: AdminImportRoute,AdminNewsletterRoute: AdminNewsletterRoute,AdminNotFoundLogRoute: AdminNotFoundLogRoute,AdminProductsByRetailerRoute: AdminProductsByRetailerRoute,AdminRedirectsRoute: AdminRedirectsRoute,AdminSidebarAdsRoute: AdminSidebarAdsRoute,AdminSubscribersRoute: AdminSubscribersRoute,AdviceSectionSlugRoute: AdviceSectionSlugRoute,AirCompressorsSlugRoute: AirCompressorsSlugRoute,AirCompressorsBuyingGuidesRoute: AirCompressorsBuyingGuidesRoute,AirCompressorsReviewsRoute: AirCompressorsReviewsRoute,ArticlesSlugRoute: ArticlesSlugRoute,AuthorsSlugRoute: AuthorsSlugRoute,BestSlugRoute: BestSlugRoute,BrowsePageRoute: BrowsePageRoute,CategoryCategorySlugRoute: CategoryCategorySlugRoute,ChainsawsSlugRoute: ChainsawsSlugRoute,ChainsawsBuyingGuidesRoute: ChainsawsBuyingGuidesRoute,ChainsawsReviewsRoute: ChainsawsReviewsRoute,CompareSlugRoute: CompareSlugRoute,DealsAmazonGardenDealsRoute: DealsAmazonGardenDealsRoute,GeneratorsSlugRoute: GeneratorsSlugRoute,GeneratorsBuyingGuidesRoute: GeneratorsBuyingGuidesRoute,GeneratorsReviewsRoute: GeneratorsReviewsRoute,GiftsFathersDayRoute: GiftsFathersDayRoute,GuidesBestLeafBlowersUkRoute: GuidesBestLeafBlowersUkRoute,LawnMowersSlugRoute: LawnMowersSlugRoute,LawnMowersBuyingGuidesRoute: LawnMowersBuyingGuidesRoute,LawnMowersReviewsRoute: LawnMowersReviewsRoute,PlantsSlugRoute: PlantsSlugRoute,PressureWashersSlugRoute: PressureWashersSlugRoute,PressureWashersBuyingGuidesRoute: PressureWashersBuyingGuidesRoute,PressureWashersReviewsRoute: PressureWashersReviewsRoute,ProductSlugRoute: ProductSlugRoute,ProductsCategorySlugRoute: ProductsCategorySlugRoute,ReviewsSectionSlugRoute: ReviewsSectionSlugRoute,ShopSlugRoute: ShopSlugRoute,SlugIndexRoute: SlugIndexRoute,AdminIndexRoute: AdminIndexRoute,AirCompressorsIndexRoute: AirCompressorsIndexRoute,ArticlesIndexRoute: ArticlesIndexRoute,AuthorsIndexRoute: AuthorsIndexRoute,BrowseIndexRoute: BrowseIndexRoute,ChainsawsIndexRoute: ChainsawsIndexRoute,GeneratorsIndexRoute: GeneratorsIndexRoute,LawnMowersIndexRoute: LawnMowersIndexRoute,PlantsIndexRoute: PlantsIndexRoute,PressureWashersIndexRoute: PressureWashersIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,AdminArticlesIdRoute: AdminArticlesIdRoute,AdminChainsawsIdRoute: AdminChainsawsIdRoute,AdminGeneratorsIdRoute: AdminGeneratorsIdRoute,AdminLawnMowersIdRoute: AdminLawnMowersIdRoute,AdminLawnMowersBulkImportRoute: AdminLawnMowersBulkImportRoute,AdminLawnMowersDuplicatesRoute: AdminLawnMowersDuplicatesRoute,AdminPagesIdRoute: AdminPagesIdRoute,AdminPressureWashersIdRoute: AdminPressureWashersIdRoute,AdminProductLandingsIdRoute: AdminProductLandingsIdRoute,AdminShoppableLandingsIdRoute: AdminShoppableLandingsIdRoute,AdminTopListsIdRoute: AdminTopListsIdRoute,AirCompressorsCategorySlugRoute: AirCompressorsCategorySlugRoute,BrandBrandSlugCategorySlugRoute: BrandBrandSlugCategorySlugRoute,BrandHyundaiSawsRoute: BrandHyundaiSawsRoute,ChainsawsCategorySlugRoute: ChainsawsCategorySlugRoute,GeneratorsBrandFilterValueRoute: GeneratorsBrandFilterValueRoute,GeneratorsCategorySlugRoute: GeneratorsCategorySlugRoute,GeneratorsFuelFilterValueRoute: GeneratorsFuelFilterValueRoute,GeneratorsTypeFilterValueRoute: GeneratorsTypeFilterValueRoute,LawnMowersBrandFilterValueRoute: LawnMowersBrandFilterValueRoute,LawnMowersCategorySlugRoute: LawnMowersCategorySlugRoute,LawnMowersPowerFilterValueRoute: LawnMowersPowerFilterValueRoute,LawnMowersTypeFilterValueRoute: LawnMowersTypeFilterValueRoute,PressureWashersCategorySlugRoute: PressureWashersCategorySlugRoute,AdminArticlesIndexRoute: AdminArticlesIndexRoute,AdminChainsawsIndexRoute: AdminChainsawsIndexRoute,AdminDataFeedsIndexRoute: AdminDataFeedsIndexRoute,AdminGeneratorsIndexRoute: AdminGeneratorsIndexRoute,AdminLawnMowersIndexRoute: AdminLawnMowersIndexRoute,AdminPagesIndexRoute: AdminPagesIndexRoute,AdminPressureWashersIndexRoute: AdminPressureWashersIndexRoute,AdminProductLandingsIndexRoute: AdminProductLandingsIndexRoute,AdminProductsIndexRoute: AdminProductsIndexRoute,AdminShoppableLandingsIndexRoute: AdminShoppableLandingsIndexRoute,AdminTopListsIndexRoute: AdminTopListsIndexRoute,BrandBrandSlugIndexRoute: BrandBrandSlugIndexRoute,AdminDataFeedsIdProductsRoute: AdminDataFeedsIdProductsRoute,AdminProductsHubIdRoute: AdminProductsHubIdRoute,AdminProductsHubIndexRoute: AdminProductsHubIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)